import React from 'react'

const SectionTitle = (props) => {
    return (
        <div className="wpo-section-title">
            <h2>{props.MainTitle}</h2>
            <p>{props.description || "Jagruti Chemicals provides a consistent and dependable supply of high-quality industrial chemicals. We ensure timely delivery and maintain strict quality standards for every shipment."}</p>
        </div>

    )
}

export default SectionTitle;